import React from "react";
import Datacard from "../../components/Datacard";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import RecentTransactions from "../../components/RecentTransactions";
import StartCreateYourTransaction from "../../components/StartCreateYourTransaction";
import { QuickActionsall } from "../../components/QuickActions";
import NoDataImg from "../../assets/TransactionDashboardIcons/Nothing.png";
import colorCode from "../../utils/colorCodeMapper";
import "./index.css";
import { useDispatch, useSelector } from "react-redux"; import { approvalStatus } from "../../services/approvalStatus";
import { useEffect } from "react";
import { getClientDashboard } from "../../redux/features/txnDashboard/txnDashboard";
import { getClientViewAll } from "../../redux/features/txnViewAll/txnViewAll";
import { txnPathMapper } from "../../services/txnPathMapper";
import { txnPayloadMapper } from "../../services/txnPayloadMapper";
import { bankLogoMapper } from "../../services/bankLogoMapper";
import { getSettleVendorTxn } from "../../redux/features/settleTxn/settleTxn";
import { clientDashboardChecks } from "../../services/clientDashboardChecks";

const ClientTransactions = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getClientDashboard());
    dispatch(getClientViewAll());
  }, []);

  const services = useSelector((state) => state.refreshToken.services);
  const clientDashboardData = useSelector((state) => state.txnDashBoard.client);

  const loading = useSelector(
    (state) => state.txnDashBoard.isLoading
  );

  const clientViewAllData = useSelector((state) => state.txnViewAll.client);

  const dataCardDetails = clientDashboardData
    ? clientDashboardChecks(clientDashboardData)
    : null;

  const recentTransactionsData = clientViewAllData
    ? clientViewAllData["transactions"].slice(0, 10)
    : null;

  const logoDataCards = [
    {
      title: <div>Bank <br /> refunds</div>,
      logo: "Card refunds.png",
      settlement_type: "Registered Card"
    },
    {
      title: <div>Netbanking <br /> Refunds</div>,
      logo: "Netbanking refunds.png",
      settlement_type: "Net Banking"

    },
    {
      title: <div>UPI <br /> refunds</div>,
      logo: "UPI refunds.png",
      settlement_type: "UPI"
    }
  ];

  const getDataCardDetailsDiv = (dataCardDetails) => {
    return dataCardDetails ? (
      <>
        {Object.entries(dataCardDetails).map(([key, value]) => {
          return (
            <Datacard
              key={key}
              color={colorCode[key]}
              text={key}
              number={value?.records}
              path={txnPathMapper("client_transactions")[key] + "?approval_status=" + txnPayloadMapper[key]?.approval_status}
            />
          );
        })}
        {logoDataCards.map((data) => {
          return (
            <Datacard
              key={data}
              text={data.title}
              imgName={data?.logo}
              path={`/client_transactions/view_refund_cards?settlement_type=${data.settlement_type}`}
            />
          );
        })}
      </>
    ) : (
      <>
        <Box sx={{ opacity: "0.5" }}>
          <Datacard
            color={"yellow"}
            text={"Processing transactions"}
            number={0}
          />
        </Box>
        <Box sx={{ opacity: "0.5" }}>
          <Datacard
            color={"green"}
            text={"Successful transactions"}
            number={0}
          />
        </Box>
      </>
    );
  }

  const getRecentTransactionsDiv = (recentTransactionsData) => {
    return recentTransactionsData.map((transaction) => {
      return (
        <RecentTransactions
          img={
            transaction?.settlement_type === "HDFC NEFT/RTGS"
              ? bankLogoMapper(transaction?.owner_bank_name)
              : transaction?.settlement_type === "Instant Pay"
                ? "Instant Pay"
                : transaction?.settlement_type === "Registered Card"
                  ? transaction?.card_type || "Default Card"
                  : "Status - pending"
          }
          amount={transaction.amount}
          account={transaction.client_name ? transaction.client_name : "+91 " + transaction.client_contact_no.replace(/(.{5})/g, '$1 ')}
          status={approvalStatus(transaction.approval_status)}
          transaction_id={transaction.txn_id}
          navigate_url={`/client/txn/${transaction.txn_id}`}
        />
      );
    });
  }

  return (

    <div className="
    bg-custom-appBack min-h-screen max-h-full
      flex flex-col-reverse lg:flex-row vendor-txn overflow-y-scroll">
      <div className="md:bg-custom-appBackLight
          flex flex-wrap justify-center lg:justify-end  w-full
          lg:w-8/12">
        <div className="
          md:pr-8 md:py-8
          lg:pr-10 lg:py-10
          xl:pr-12 xl:py-12
          4xl:pr-24 4xl:py-24
          mt-24 w-full xl:w-11/12 flex flex-col
          gap-4 2xl:gap-6 3xl:gap-8 4xl:gap-16 6xl:gap-24">

          <div className="
            grid gap-6 4xl:gap-16 grid-cols-2
            lg:grid-cols-4
            2xl:grid-cols-5
            4xl:grid-cols-6
            5xl:grid-cols-7
            justify-items-center">
            {getDataCardDetailsDiv(dataCardDetails)}
          </div>

          {
            loading && <div className="w-full m-auto justify-center items-center flex" >
              <img src={require("../../assets/Approve transactions/inputloder.gif")} alt="" />
            </div>
          }
          {!loading &&

            <div className="p-2 flex flex-col h-full">
              {recentTransactionsData?.length ? (
                <>
                  <div className="px-4 flex flex-row justify-between">
                    <span className="text-white
                    text-xl
                    3xl:text-2xl
                    4xl:text-3xl
                    5xl:text-4xl">
                      Recent
                    </span>
                    <span className="cursor-pointer
                    text-xl
                    3xl:text-2xl
                    4xl:text-3xl
                    5xl:text-4xl">
                      <p onClick={() => navigate("/client_transactions/view_all_transactions")} className="underline text-custom-orange">View All</p>
                    </span>
                  </div>

                  <div className="pb-6 3xl:pb-8 5xl:pb-10
                  mt-5 w-full
                  gap-y-4 4xl:gap-y-8
                  grid grid-cols-1
                  md:grid-cols-2
                  3xl:grid-cols-3
                  md:gap-x-8
                  lg:gap-x-10
                  justify-items-center">
                    {getRecentTransactionsDiv(recentTransactionsData)}
                  </div>
                </>
              ) : (
                <>
                  <Typography className="pt-8" sx={{
                    color: "white", margin: "auto", textAlign: "center"
                  }}>
                    No transactions found <br />
                    All client transactions will appear here.
                  </Typography>
                  <Box
                    sx={{
                      width: "50%",
                      margin: "auto",
                      marginTop: "5%",
                    }}
                  >
                    <img width={"100%"} src={NoDataImg} alt="NoDataImg" />
                  </Box>
                </>
              )}
            </div>
          }
        </div>
        <div className="p-2 visible xl:p-0 xl:w-0 xl:h-0 xl:invisible">
          <QuickActionsall />
        </div>
      </div>
      <div className="
          h-full lg:fixed lg:right-0
          p-4
          md:pl-8 md:py-8
          lg:pl-10 lg:py-10
          xl:pl-12 xl:py-12
          4xl:pl-24 4xl:py-24
          flex flex-col bg-custom-appBack
          w-full lg:w-4/12 overflow-y-scroll overflow-x-hidden md:overflow-y-auto hide-scrollbar">
        <div className="
            mt-24 w-full lg:w-11/12
            flex flex-col
            gap-10 2xl:gap-12 3xl:gap-16 4xl:gap-20
            justify-items-center">
          <div className="">
            <StartCreateYourTransaction
              create_path="/create_transaction/client_transaction"
              viewall_path="/client_transactions/view_all_transactions"
            />
          </div>
          <div className="hidden lg:block">
            <QuickActionsall />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientTransactions;
